import { getConsent } from '@/lib/consent';

/**
 * Stolzl via Adobe Fonts (Typekit web project).
 * Enter the kit ID from fonts.adobe.com → Web Projects (e.g. "abc1def").
 * Until then the local Inter fallback is used.
 * GDPR: the kit is a third-party request, so it only loads after marketing consent.
 */
export const ADOBE_FONTS_KIT_ID = '';

const LINK_ID = 'h2h-adobe-fonts';

export function loadAdobeFontsIfAllowed(): void {
  if (!ADOBE_FONTS_KIT_ID || typeof document === 'undefined') return;
  if (document.getElementById(LINK_ID)) return;
  if (getConsent()?.marketing !== true) return;
  const link = document.createElement('link');
  link.id = LINK_ID;
  link.rel = 'stylesheet';
  link.href = `https://use.typekit.net/${ADOBE_FONTS_KIT_ID}.css`;
  document.head.appendChild(link);
}

export function initAdobeFonts(): void {
  loadAdobeFontsIfAllowed();
  window.addEventListener('h2h-consent-change', loadAdobeFontsIfAllowed);
}
